const resource = '/v1/landings';

export default $axios => ({
  show(url) {
    return $axios.get(`${resource}/${url}`)
  },
  showPublic(url) {
    return $axios.get(`${resource}/public/${url}`)
  },
  getNumberApplications() {
    return $axios.get('/v1/number-application');
  },
  getPublicApplication() {
    return $axios.get(`${resource}/get-applications`)
  },
  getCategoryWithPublicApplication() {
    return $axios.get(`${resource}/get-category-with-public-application`)
  }
});
